
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      required: true,
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    rows: {
      type: String,
      default: "5"
    },
    maxLength: {
      type: Number,
      required: false
    },
    hasCharacterCounter: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
